import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TransitionIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M16.286 2H3.714C2.768 2 2 2.768 2 3.714v12.572C2 17.233 2.768 18 3.714 18h12.572c.947 0 1.714-.767 1.714-1.714V3.714C18 2.768 17.233 2 16.286 2zm.571 14.286c0 .315-.256.571-.571.571H3.714c-.315 0-.571-.256-.571-.571V3.714c0-.315.256-.571.571-.571h12.572c.315 0 .571.256.571.571v12.572zM5.554 14.244c-.167-.168-.167-.439 0-.606l6.97-6.97-.025-.025-3.213.012c-.237 0-.429-.192-.429-.429V5.87c0-.236.192-.428.429-.428l4.857-.012c.237 0 .428.191.428.428l-.012 4.857c0 .237-.192.429-.428.429h-.357c-.237 0-.43-.192-.43-.429l.013-3.213-.025-.025-6.97 6.97c-.167.167-.438.167-.606 0l-.202-.202z" />
        </SvgIcon>
    );
};
